






























import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import {
  expenseReimbursementMethodMap,
  expenseReimbursementStatusMap,
} from "@/shared/types";
import { formatCurrency } from "@/shared/currency.js";
import { useHsabExpenseFormStore } from "@/employee/store/hsabExpenseForm";

@Component({})
export default class HsabExpenseCardRowRepayments extends Vue {
  formatCurrency = formatCurrency;
  hsabExpenseFormStore = useHsabExpenseFormStore();
  expenseReimbursementMethodMap = expenseReimbursementMethodMap;
  expenseReimbursementStatusMap = expenseReimbursementStatusMap;

  get expense () {
    return this.hsabExpenseFormStore.expense;
  }
  get hasRepayments () {
    return this.hsabExpenseFormStore.hasExpense
        && this.expense.reimbursement
        && this.expense.reimbursement.repayments
        && this.expense.reimbursement.repayments.length > 0;
  }

  get repayments () {
    return this.expense.reimbursement.repayments;
  }
}
